module.exports = __webpack_public_path__ + "media/assets/images/blog/tech_granpa-small-b651e0493dae67f76244ba56eb02c233.jpeg";